<template>
  <div id="feedback-index">
    <div class="common-level-rail">
      <span>投诉反馈列表</span>
    </div>

    <div class="product-content">
      <el-table size="small" :data="list" border style="width: 100%">
        <el-table-column prop="feedback_id" label="ID" width="70" />
        <el-table-column label="用户信息" min-width="220">
          <template slot-scope="scope">
            <div>用户ID：{{ scope.row.user ? scope.row.user.user_id : '-' }}</div>
            <div>昵称：{{ scope.row.user ? scope.row.user.nickName : '-' }}</div>
            <div>手机号：{{ scope.row.user ? scope.row.user.mobile : '-' }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="title" label="标题" min-width="180" />
        <el-table-column label="类型" width="80">
          <template slot-scope="scope">
            <el-tag size="small" :type="scope.row.type == 1 ? 'danger' : 'info'">
              {{ scope.row.type == 1 ? '投诉' : '反馈' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="content" label="内容" min-width="260" show-overflow-tooltip />
        <el-table-column label="状态" width="100">
          <template slot-scope="scope">
            <el-tag size="small" :type="scope.row.status == 1 ? 'success' : 'warning'">
              {{ scope.row.status == 1 ? '已处理' : '未处理' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="create_time" label="创建时间" width="160" />
        <el-table-column label="操作" width="120" fixed="right">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="toggleStatus(scope.row)"
            >
              {{ scope.row.status == 1 ? '标记未处理' : '标记已处理' }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination
          @current-change="pageChange"
          background
          :current-page="searchObj.page"
          :page-size="searchObj.list_rows"
          layout="total, prev, pager, next, jumper"
          :total="total"
        />
      </div>
    </div>
  </div>
</template>

<script>
import FeedbackApi from '@/api/feedback.js'

export default {
  data() {
    return {
      searchObj: {
        page: 1,
        list_rows: 10,
      },
      list: [],
      total: 0,
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      FeedbackApi.feedbackList(this.searchObj).then(res => {
        const list = res.data.list
        this.list = list.data
        this.total = list.total
      })
    },
    pageChange(e) {
      this.searchObj.page = e
      this.getData()
    },
    toggleStatus(row) {
      const newStatus = row.status == 1 ? 0 : 1
      const text = newStatus == 1 ? '标记为已处理' : '标记为未处理'
      this.$confirm(`确认将该条反馈${text}？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          FeedbackApi.feedbackSetStatus({
            feedback_id: row.feedback_id,
            status: newStatus,
          }).then(() => {
            this.$message({ message: '操作成功', type: 'success' })
            this.getData()
          })
        })
        .catch(() => {})
    },
  },
}
</script>

<style scoped>
</style>

<template>
  <div id="feedback-index">
    <div class="common-level-rail">
      <span>投诉反馈列表</span>
    </div>

    <div class="product-content">
      <el-table size="small" :data="list" border style="width: 100%">
        <el-table-column prop="feedback_id" label="ID" width="70" />
        <el-table-column label="用户信息" min-width="220">
          <template slot-scope="scope">
            <div>用户ID：{{ scope.row.user ? scope.row.user.user_id : '-' }}</div>
            <div>昵称：{{ scope.row.user ? scope.row.user.nickName : '-' }}</div>
            <div>手机号：{{ scope.row.user ? scope.row.user.mobile : '-' }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="title" label="标题" min-width="180" />
        <el-table-column label="类型" width="80">
          <template slot-scope="scope">
            <el-tag size="small" :type="scope.row.type == 1 ? 'danger' : 'info'">
              {{ scope.row.type == 1 ? '投诉' : '反馈' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="content" label="内容" min-width="260" show-overflow-tooltip />
        <el-table-column label="状态" width="100">
          <template slot-scope="scope">
            <el-tag size="small" :type="scope.row.status == 1 ? 'success' : 'warning'">
              {{ scope.row.status == 1 ? '已处理' : '未处理' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="create_time" label="创建时间" width="160" />
        <el-table-column label="操作" width="120" fixed="right">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="toggleStatus(scope.row)"
            >
              {{ scope.row.status == 1 ? '标记未处理' : '标记已处理' }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination
          @current-change="pageChange"
          background
          :current-page="searchObj.page"
          :page-size="searchObj.list_rows"
          layout="total, prev, pager, next, jumper"
          :total="total"
        />
      </div>
    </div>
  </div>
</template>

<script>
import FeedbackApi from '@/api/feedback.js'

export default {
  data() {
    return {
      searchObj: {
        page: 1,
        list_rows: 10,
      },
      list: [],
      total: 0,
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      FeedbackApi.feedbackList(this.searchObj).then(res => {
        const list = res.data.list
        this.list = list.data
        this.total = list.total
      })
    },
    pageChange(e) {
      this.searchObj.page = e
      this.getData()
    },
    toggleStatus(row) {
      const newStatus = row.status == 1 ? 0 : 1
      const text = newStatus == 1 ? '标记为已处理' : '标记为未处理'
      this.$confirm(`确认将该条反馈${text}？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          FeedbackApi.feedbackSetStatus({
            feedback_id: row.feedback_id,
            status: newStatus,
          }).then(() => {
            this.$message({ message: '操作成功', type: 'success' })
            this.getData()
          })
        })
        .catch(() => {})
    },
  },
}
</script>

<style scoped>
</style>




// WEBPACK FOOTER //
// src/views/feedback/feedback/index.vue